import { render } from "./News.vue?vue&type=template&id=f8ecc7ba&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=f8ecc7ba&scoped=true&lang=postcss"
script.render = render
script.__scopeId = "data-v-f8ecc7ba"

export default script